// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-icon-tooltip-button .fi-icon-tooltip-wrapper {
  cursor: pointer;
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon {
  background-color: var(--fi-color-tinted-white);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon.green-icon {
  color: var(--fi-color-green-contrast);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon.blue-icon {
  color: var(--fi-color-primary-blue);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon.red-icon {
  color: var(--fi-color-red);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon.branded-icon {
  color: var(--branded-color);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon:not(.blank-icon-background).green-icon {
  background-color: var(--fi-color-green-light);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon:not(.blank-icon-background).blue-icon {
  background-color: var(--fi-color-blue-light);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon:not(.blank-icon-background).red-icon {
  background-color: var(--fi-color-red-light);
}
.fi-icon-tooltip-button .fi-icon-tooltip-wrapper:hover .mat-icon:not(.blank-icon-background).branded-icon {
  background-color: var(--branded-color-01);
}
.fi-icon-tooltip-button .mat-icon {
  background-color: transparent;
  border-radius: 50%;
  font-size: 18px;
  width: 40px;
  height: 40px;
  text-align: center;
  line-height: 40px;
  color: var(--fi-color-steel-grey);
  opacity: 0;
  transition: all 0.2s;
}
.fi-icon-tooltip-button .mat-icon.shown {
  opacity: 1;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-icon-tooltip-button/fi-icon-tooltip-button.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;AAGY;EACI,8CAAA;AADhB;AAEgB;EACI,qCAAA;AAApB;AAEgB;EACI,mCAAA;AAApB;AAEgB;EACI,0BAAA;AAApB;AAEgB;EACI,2BAAA;AAApB;AAGoB;EACI,6CAAA;AADxB;AAGoB;EACI,4CAAA;AADxB;AAGoB;EACI,2CAAA;AADxB;AAGoB;EACI,yCAAA;AADxB;AAOI;EACI,6BAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,iCAAA;EACA,UAAA;EACA,oBAAA;AALR;AAOQ;EACI,UAAA;AALZ","sourcesContent":[".fi-icon-tooltip-button {\r\n    .fi-icon-tooltip-wrapper {\r\n        cursor: pointer;\r\n\r\n        &:hover {\r\n            .mat-icon {\r\n                background-color: var(--fi-color-tinted-white);\r\n                &.green-icon {\r\n                    color: var(--fi-color-green-contrast);\r\n                }\r\n                &.blue-icon {\r\n                    color: var(--fi-color-primary-blue);\r\n                }\r\n                &.red-icon {\r\n                    color: var(--fi-color-red);\r\n                }\r\n                &.branded-icon {\r\n                    color: var(--branded-color);\r\n                }\r\n                &:not(.blank-icon-background) {\r\n                    &.green-icon {\r\n                        background-color: var(--fi-color-green-light);\r\n                    }\r\n                    &.blue-icon {\r\n                        background-color: var(--fi-color-blue-light);\r\n                    }\r\n                    &.red-icon {\r\n                        background-color: var(--fi-color-red-light);\r\n                    }\r\n                    &.branded-icon {\r\n                        background-color: var(--branded-color-01);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .mat-icon {\r\n        background-color: transparent;\r\n        border-radius: 50%;\r\n        font-size: 18px;\r\n        width: 40px;\r\n        height: 40px;\r\n        text-align: center;\r\n        line-height: 40px;\r\n        color: var(--fi-color-steel-grey);\r\n        opacity: 0;\r\n        transition: all 0.2s;\r\n\r\n        &.shown {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
